import { YourFeedback } from "@/app/components/common/actions/inputs-b/YourFeedbackText";

export default function feedback({
  setFeedback,
  feedback,
}: {
  setFeedback: (value: string) => void;
  feedback: string;
}) {
  const handleFeedbackChange = (value: string) => {
    setFeedback(value);
  };

  return (
    <div className="grid grid-cols-12 gap-4">
      <div className="col-span-12">
        <YourFeedback
          label="Description"
          value={feedback}
          onChange={handleFeedbackChange}
        />
      </div>
    </div>
  );
}
